import { createSlice } from '@reduxjs/toolkit';
import { getTemplatesDefaultData } from '@web-setting/Mail/components/CustomTemplate/util';
const InitialState = {
    mailTemplateContent: {},
    showContact: false,
    mailTemplateName: '',
    showTemplateList: false,
    showTemplateListType: '',
    showAddTemplatePop: false,
    showAddTemplatePopSource: '',
    defaultActiveTab: 0,
    isModified: false,
    isClosePreviewModal: false,
};
const mailTemplateSlice = createSlice({
    name: 'mailTemplateReducer',
    initialState: InitialState,
    reducers: {
        changeShowTemplateList: (state, action) => {
            const { isShow, defaultActiveTab = 0, templateType = '' } = action.payload;
            state.defaultActiveTab = defaultActiveTab;
            state.showTemplateList = isShow;
            if (isShow && templateType) {
                state.showTemplateListType = templateType;
            }
            if (!isShow) {
                state.showAddTemplatePopSource = '';
                state.showTemplateListType = '';
            }
        },
        changeShowAddTemplatePop: (state, action) => {
            const { isShow, source = '', isModified } = action.payload;
            state.showAddTemplatePop = isShow;
            if (isShow) {
                state.showAddTemplatePopSource = source;
                state.isModified = !!isModified;
            }
            if (!isShow && state.showAddTemplatePopSource === 'list') {
                state.showTemplateList = true;
                state.defaultActiveTab = 2;
            }
        },
        doModifyTemplateName: (state, action) => {
            state.mailTemplateName = action.payload;
        },
        doWriteTemplate: (state, action) => {
            state.mailTemplateContent = action.payload;
            state.showContact = false;
        },
        doMailTemplateInit: state => {
            const originData = getTemplatesDefaultData();
            state.mailTemplateContent = originData;
            state.mailTemplateName = '';
            state.showContact = false;
        },
        doModifyReceiver: (state, action) => {
            const { receiver, receiverType, operation } = action.payload;
            if (operation === 'paste') {
                const unModifed = state.mailTemplateContent.receiver.filter(r => r.mailMemberType !== receiverType);
                const filtered = state.mailTemplateContent.receiver
                    .filter(r => r.mailMemberType === receiverType);
                const result = [...filtered, ...receiver]
                    .filter((item, index, arr) => index === arr.findIndex(t => t.contact.contact.accountName === item.contact.contact.accountName));
                state.mailTemplateContent.receiver = [...unModifed, ...result];
                return;
            }
            if (operation === 'delete') {
                const unModifed = state.mailTemplateContent.receiver.filter(r => r.mailMemberType !== receiverType);
                const filtered = state.mailTemplateContent.receiver
                    .filter(r => r.mailMemberType === receiverType)
                    .filter(r => !receiver.includes(r.contact.contact.accountName));
                state.mailTemplateContent.receiver = [...unModifed, ...filtered];
                return;
            }
            const filteredReceiver = state.mailTemplateContent.receiver.filter(item => item && item.mailMemberType !== receiverType) || [];
            state.mailTemplateContent.receiver = [...receiver, ...filteredReceiver];
        },
        doFocusTitle: (state, action) => {
            state.mailTemplateContent.focusTitle = action.payload;
        },
        doModifySubject: (state, action) => {
            state.mailTemplateContent.entry.title = action.payload;
        },
        doShowWriteContact: (state, action) => {
            state.mailTemplateContent.status.showContact = action.payload;
        },
        doChangeMailContent: (state, action) => {
            var _a, _b, _c;
            if ((_c = (_b = (_a = state.mailTemplateContent) === null || _a === void 0 ? void 0 : _a.entry) === null || _b === void 0 ? void 0 : _b.content) === null || _c === void 0 ? void 0 : _c.content) {
                state.isModified = true;
            }
            state.mailTemplateContent.entry && (state.mailTemplateContent.entry.content.content = action.payload);
        },
        doReplaceReceiver: (state, action) => {
            state.mailTemplateContent.receiver = [...action.payload];
        },
        doAfterInit: (state, action) => {
            state.mailTemplateContent.status.init = action.payload;
        },
        doCCShow: (state, action) => {
            if (state.mailTemplateContent && state.mailTemplateContent.status) {
                state.mailTemplateContent.status.cc = action.payload;
            }
        },
        doBCCShow: (state, action) => {
            var _a;
            if (!((_a = state === null || state === void 0 ? void 0 : state.mailTemplateContent) === null || _a === void 0 ? void 0 : _a.status))
                return;
            state.mailTemplateContent.status.bcc = action.payload;
        },
        doConferenceSettting: (state, action) => {
            state.mailTemplateContent.status.conferenceSetting = action.payload;
        },
        doClosePreviewModal: (state, action) => {
            state.isClosePreviewModal = action.payload;
        },
    },
});
export const { actions } = mailTemplateSlice;
export default mailTemplateSlice.reducer;
